import { Card, MonoLabel, Skeleton } from '@/design-system';
import type { TimelineEntry } from '@/entities/order';
import { formatDayTimeShort } from '@/shared/lib';
import { CardTitleRow } from '@/shared/ui';

import { dossierCopy } from '../copy';

export interface TimelineCardProps {
    entries: readonly TimelineEntry[];
    loading?: boolean;
}

/**
 * De tijdlijn van de keuring, inclusief wat de server zelf deed. Automatische
 * stappen staan er net zo goed in - anders lijkt het alsof er niets gebeurde.
 */
export function TimelineCard({ entries, loading = false }: TimelineCardProps) {
    return (
        <Card clip id="tijdlijn" className="scroll-mt-4">
            <CardTitleRow title={dossierCopy.timelineTitle} />

            {loading ? (
                <div className="px-4 py-[13px]">
                    <Skeleton height={14} width="60%" pulse label={dossierCopy.timelineTitle} />
                </div>
            ) : entries.length === 0 ? (
                <p className="m-0 px-4 py-[13px] text-[13px] text-[var(--text-tertiary-safe)]">
                    {dossierCopy.timelineEmpty}
                </p>
            ) : (
                <ol className="m-0 list-none p-0">
                    {entries.map((entry) => (
                        <li
                            key={entry.key}
                            className="grid gap-[14px] border-b border-[var(--border-subtle-2)] px-4 py-[13px] [grid-template-columns:96px_1fr]"
                        >
                            <MonoLabel size={11} variant="value" tone="muted">
                                {entry.at ? formatDayTimeShort(entry.at) : dossierCopy.unknown}
                            </MonoLabel>
                            <div>
                                <div className="text-[14px] leading-[1.35] font-medium text-[var(--text-primary)]">
                                    {entry.label}
                                </div>
                                <div className="mt-[3px] text-[12px] text-[var(--text-tertiary-safe)]">
                                    {entry.automatic
                                        ? dossierCopy.timelineAutomatic
                                        : (entry.actorName ?? dossierCopy.timelineUnknownActor)}
                                </div>
                            </div>
                        </li>
                    ))}
                </ol>
            )}
        </Card>
    );
}
